export enum EntityType {
  organization = 'organization',
  payment = 'payment',
  melioMe = 'melio.me',
  vendor = 'vendor',
  deliveryMethod = 'deliveryMethod',
  fundingSource = 'fundingSource',
  payorIp = 'payorIp',
  paymentIp = 'paymentIp',
  updateIp = 'updateIp',
  payeeIp = 'payeeIp'
}

export default EntityType;
